import { useState, useEffect } from 'react'

import useMediaQuery from '@mui/material/useMediaQuery'

import { isServer } from 'src/libs/helper'
import { BreakPoints } from 'src/responsive'

export const useDevice = () => {
  const [windowSize, setWindowSize] = useState<{
    width: number | undefined
    height: number | undefined
  }>({
    width: undefined,
    height: undefined,
  })
  const isPC = useMediaQuery(`(min-width:${BreakPoints.laptop})`)
  const isGreaterTablet = useMediaQuery(`(min-width:${BreakPoints.tablet})`)

  useEffect(() => {
    if (isServer) {
      return
    }
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    windowSize,
    isPC,
    isGreaterTablet,
  }
}
